module.exports = __webpack_public_path__ + "assets/img/wechat.b747da55.png";